import { render, staticRenderFns } from "./BlockChooser.vue?vue&type=template&id=81cd4546&scoped=true&"
import script from "./BlockChooser.vue?vue&type=script&lang=ts&"
export * from "./BlockChooser.vue?vue&type=script&lang=ts&"
import style0 from "./BlockChooser.vue?vue&type=style&index=0&id=81cd4546&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cd4546",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VDialog,VList,VListItem})
